import React from 'react';
import classNames from 'classnames';

import './style.css';

const MyCheckbox = ({ name, values = null, isExist = null }) => {
    const isCheck = isExist !== null ? isExist : values[name];

    const checkboxClass = classNames({
        checkboxWrapper: true,
        checked: isCheck,
        unchecked: !isCheck,
    });

    return <div className={checkboxClass} />;
};

export default MyCheckbox;
